<template>
  <div id="app">
      <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-size: 16px;
}
* {
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: #2187c6 !important;
}
.container {
  padding: 30px 15px;
}
.form-header {
  font-size: 20px;
  padding-bottom: 8px;
  font-weight: 500;
}
.form-group {
  padding-top: 10px;
  margin-bottom: 5px !important;
}
.form-control {
  border: none !important;
  border-bottom: 1px solid #000000 !important;
  width: 100%;
  line-height: 35px;
  height: 35px;
  font-size: 16px;
  color: #2187c6;
  padding: 0 6px;
  border-radius: 0 !important;
}
.form-control.form-error {
  border-bottom: 1px solid red;
  color: red;
}
.form-control:focus {
  outline: 0;
}
label {
  font-size: 16px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-error {
  color: red;
  margin-bottom: 0;
  margin-top: 5px;
}
.text-help-call {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 18px;
}
.text-help {
  color: gray;
  padding-top: 10px;
}
.list-sip {
  margin: 0;
  padding: 0;
  border: 1px solid #777777;
}
.list-sip li {
  list-style: none;
  cursor: pointer;
  position: relative;
  padding-right: 40px;
}
.list-sip li a {
  border-bottom: 1px solid #777777;
  margin: 0 10px;
  line-height: 40px;
  display: block;
  color: #000000 !important;
}
.list-sip li.active {
  background: #2388c6;
  color: #ffffff !important;
}
.list-sip li.active a {
  color: #ffffff !important;
}
.list-sip li:last-child a {
  border: none;
}
.list-sip svg {
  float: right;
  line-height: 40px;
  font-size: 22px;
  color: #777777;
  margin-top: 9px;
  position: absolute;
  right: 8px;
  top: 0;
}
.list-sip li.active svg {
  color: #ffffff !important;
}
.text-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.form-code {
  padding: 0 10px 0 22px;
}
.btn-submit {
  margin-top: 10px;
}
.text-link {
  color: #0d6aad;
}
.row {
  margin: 0 -10px;
}
.row:after {
  clear: both;
}
.col-xs-6 {
  width: 50%;
  padding: 0 10px;
  float: left;
}
.btn-block {
  padding: 0 !important;
  margin: 0 auto;
}
.btn-start {
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 80px;
}
.form-verify {
  padding: 20px 50px;
}
.phone-number {
  font-size: 20px;
}
.text-note {
  color: #666666;
}
.code-prefix {
  position: absolute;
  margin-top: 10px;
}
.code-resend {
  color: #2187c6;
  margin-top: 8px;
}
.code-resend.disable, .disableResend {
  opacity: 0.4;
}
.term-checkbox {
  padding-top: 20px;
}
.mb5 {
  margin-bottom: 5px;
}
.mt0 {
  margin-top: 0 !important;
}
.clearfix::after {
  content: "";
  clear: both;
  display: block;
}
.box-list-sip {
  margin-top: 40px;
}
.fl-right {
  float: right;
}
.input-group {
  position: relative;
}
.input-group input {
  position: relative;
  padding-right: 110px;
}
.input-group-append {
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 35px;
  padding: 0 15px;
}
.alert {
  padding: 10px !important;
}
.sipListNote {
  color: gray;
  margin-top: 5px;
  margin-bottom: 15px;
}
.fileIco {
  border: 4px solid #777777;
  width: 20px;
  display: inline-block;
  height: 20px;
  border-radius: 45px;
  top: 5px;
  position: absolute;
  right: 8px;
  top: 10px;
}
.sipListNote .fileIco {
  position: relative;
  right: 0;
  top: 2px;
}
input[type="text"]:disabled , input[type="email"]:disabled, input[type="password"]:disabled  {
  background: #dddddd;
}
input:disabled, textarea:disabled {
  color: rgb(84, 84, 84) !important;
  cursor: default;
}
.col-xs-12 {
  width: 100%;
  padding: 0 10px;
}
.col-xs-4 {
  width: 33.33%;
  padding: 0 10px;
  float: left;
}
.medial-body, .medial-footer {
  text-align: center;
  margin: auto;
}
.logo-ccall {
  max-width: 200px;
}
.medial-body {
  margin-top: 30%;
}
.medial-footer {
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 80px;
}
.private-policy-link {
  color: inherit;
  text-decoration: underline;
}
.btn {
  width: 100%;
  font-size: 16px !important;
  padding: 0 10px !important;
}
.mt30per {
  margin-top: 30%;
}
.mb30 {
  margin-bottom: 30px;
}
.mt10 {
  margin-top: 10px;
}
input.form-control {
  z-index: 0 !important;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: none !important;
}
.input-group-append {
  z-index: 1;
}
p {
  margin-bottom: 10px !important;
}
.mt25 {
    margin-top: 25px;
}
.btn-group, .btn-group-vertical {
  width: 100%;
  height: 44px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
    border-radius: 0.3rem !important;
}
.btn-group > .btn:first-child {
  margin-left: 0 !important;
  margin-right: 3px !important;
}
.btn-group > .btn:last-child {
  margin-right: 0 !important;
  margin-left: 3px !important;
}
.event-image {
  width: 100%;
  height: auto;
  max-height: 500px;
}
.custom-bgr-primary {
  background-color: #2388c6 !important;
  border-color: #2388c6 !important;
}
.custom-bgr-danger {
  background-color: #ec4237 !important;
  border-color: #ec4237 !important;
}

.register-page {
      background: url(/static/background/bg-register.jpg) center center no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: absolute;
}

.info-page {
      background: url(/static/background/bg-info.jpg) center center no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: absolute;
}

.container-register-page {
    background-color: rgba(244,244,244,.7);
    border: none;
    border-radius: 5px;
    padding: 30px !important;
}

.register-page .form-control {
    background-color: transparent !important;
    border-bottom: 1px solid #3e3e3e !important;
}

.register-page .custom-control-label::before {
  background-color: #ffffff;
}

.register-page .custom-control-inline {
      margin-right: 3px;
}

.container-info-page {
  color: #ffffff;
}

.info-page::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,.6);
}

.box-info-user ul {
  margin-top: 30px;
  padding: 5px 30px;
  background-color: rgb(130, 212, 253, .8)
}

.box-info-user ul li {
  display: block;
  padding: 12px 0;
  border-bottom: 1px solid #36b4ff;
}

.box-info-user ul li:last-child {
  border-bottom: none;
}

.box-info-user ul li span:first-child {
  min-width: 200px;
  display: inline-block;
}

.box-info-user ul li span:last-child {
  display: inline-block;
}

.box-info-user h4 {
  margin-bottom: 20px;
}

.box-info-user p {
  margin-bottom: 3px !important;
}

.box-app-link h1 {
  font-size: 60px;
  color: #36b4ff;
}

.box-app-link p {
  font-size: 22px;
}

.box-app-link .app-play-store {
  margin-top: 160px;
}

.btn-advanced-setting {
  color: #EF4036 !important;
  border-color: #EF4036 !important;
  height: 48px !important;
}

.btn-outline-warning:hover {
  border-color: #2187c6 !important;
  background-color: #2187c6 !important;
  color: #ffffff !important;
}

.img-sendcode {
  position: relative;
  top: -16px;
}

.link-login {
  text-align: center;
  margin-top: 30px;
}

@media (max-width: 992px){
  .box-app-link .app-play-store {
      margin-top: 0;
      margin-bottom: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid #ffffff;
  }

  .info-page {
      /*
      height: auto;
      width: auto;
      */
      position: inherit;
  }

  .box-app-link p {
      font-size: 20px;
  }

  .box-info-user ul {
      margin-top: 30px;
      padding: 5px 10px;
      background-color: rgb(130, 212, 253, .8);
  }

  .box-info-user ul li span:first-child {
      min-width: 150px;
  }

  .box-info-user ul {
    font-size: 14px;
  }

  .container-register-page {
      padding: 30px 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue